import { administrationRoutes } from './administrationRoutes';
import { childOrganizationRoutes } from './childOrganizationRoutes';
import { registryRoutes } from './registryRoutes';
import { reportRoutes } from './reportRoutes';

export const authorizedRoutes = (t: (key: string) => string) => [
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../../views/DashboardPage.vue'),
    meta: { requiresAuth: true, title: t('dashboard.pageHeading') }
  },
  {
    path: '/user-profile',
    name: 'UserProfile',
    component: () => import('../../views/UserProfile.vue'),
    meta: { requiresAuth: true, title: t('userAdministration.userProfile') }
  },
  ...reportRoutes(t),
  ...childOrganizationRoutes(t),
  ...registryRoutes(t),
  ...administrationRoutes(t)
];
